/**
 * @generated SignedSource<<4306e3af5e429c913c14e2e3896d32d7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleLinkingDataContent$data = {
  readonly sectionsV2: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly name?: string;
      readonly urlAlias?: string;
      readonly urlRedirect?: {
        readonly toUrl: string;
      } | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"entityLink" | "helpersCheckIfNewsSectionInFirstIndexSection">;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly urlAlias: string;
  readonly " $fragmentType": "articleLinkingDataContent";
};
export type articleLinkingDataContent$key = {
  readonly " $data"?: articleLinkingDataContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleLinkingDataContent">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v1/*: any*/),
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "UrlRedirect",
    "kind": "LinkedField",
    "name": "urlRedirect",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "toUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v3 = [
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleLinkingDataContent",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegmentV2",
      "kind": "LinkedField",
      "name": "sectionsV2",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": (v2/*: any*/),
              "type": "Section",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v2/*: any*/),
              "type": "VideoSection",
              "abstractKey": null
            },
            {
              "kind": "InlineDataFragmentSpread",
              "name": "helpersCheckIfNewsSectionInFirstIndexSection",
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": (v3/*: any*/),
                  "type": "Section",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v3/*: any*/),
                  "type": "VideoSection",
                  "abstractKey": null
                }
              ],
              "args": null,
              "argumentDefinitions": []
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "entityLink"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};
})();

(node as any).hash = "b519a0660b4e876ac37478907d7e30bd";

export default node;
